import {
  GET_WO_PROCESS_LOG_REPORT_FAILURE,
  GET_WO_PROCESS_LOG_REPORT_SUCCESS,
  GET_WO_PROCESS_LOG_REPORT_REQUEST,
} from "./woProcessLogTypes";

const initialState = {
  loading: false,
  woProcessLog: [],
  error: "",
};

const getWoProcessLogReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WO_PROCESS_LOG_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_WO_PROCESS_LOG_REPORT_SUCCESS:
      return {
        loading: false,
        woProcessLog: action.payload,
        error: "",
      };
    case GET_WO_PROCESS_LOG_REPORT_FAILURE:
      return {
        loading: false,
        woProcessLog: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getWoProcessLogReportReducer };
